import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  const phone = "917875555877";
  const text = encodeURIComponent("Hello HiCare, I would like to enquire about lab equipment.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-emerald-600 px-4 py-3 text-white shadow-2xl shadow-emerald-600/30 transition-transform hover:scale-105 hover:bg-emerald-700"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-30" aria-hidden="true" />
      <MessageCircle className="relative h-5 w-5" />
      <span className="relative hidden text-sm font-semibold sm:inline">WhatsApp</span>
    </a>
  );
}
